import React, { useEffect } from "react";
import queryString from "query-string";

import StorefrontIcon from "@material-ui/icons/Storefront";
import SettingsIcon from "@material-ui/icons/Settings";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import DeleteIcon from "@material-ui/icons/Delete";

import Title from "../../../components/basics/Title";
import useMarketPlacesController from "./MarketplacesController";
import TabsErp from "../../../components/tabs/TabsErp";
import MarketplacesTabMarketplaces from "./MarketplacesTabMarketplaces";
import MarketplacesTabProdutos from "./MarketplacesTabProdutos";
import {
  findFabricante,
  findGrupo,
  findEstoque,
} from "../../../repository/components/estoque/EstoqueService";
import {
  useCnpj,
  useGrupos,
  useFabricantes,
  useEstoques,
  useGruposLoading,
  useFabricantesLoading,
  useEstoquesLoading,
  useMarketplaceList,
  useTabIndex,
  useMarketplacesConectados,
  useMarketplace,
  useEmpresa,
} from "../../../context/integracao/MarketplacesContext";
import MarketplacesTabDesconectar from "./MarketplacesTabDesconectar";
import MarketplacesTabConfiguracoes from "./MarketplacesTabConfiguracoes";
import { findEmpresa } from "../../../repository/ERP/prouser/EmpresaService";

import "./Marketplaces.css";

const Marketplaces = (props) => {
  // Busca de parametros enviados pelo acesso
  let params = queryString.parse(props.location.search);

  const marketplaceId = sessionStorage.getItem("marketplaceId");

  // Filtros
  const { setGrupos } = useGrupos();
  const { setFabricantes } = useFabricantes();
  const { setEstoques } = useEstoques();
  const { setGruposLoading } = useGruposLoading();
  const { setFabricantesLoading } = useFabricantesLoading();
  const { setEstoquesLoading } = useEstoquesLoading();
  const { marketplaceList, setMarketplaceList } = useMarketplaceList();
  const { tabIndex, setTabIndex } = useTabIndex();
  const { marketplacesConectados, setMarketplacesConectados } =
    useMarketplacesConectados();
  const { marketplace, setMarketplace } = useMarketplace();
  const { cnpj, setCnpj } = useCnpj();
  const { empresa, setEmpresa } = useEmpresa();

  // Adiciona as funções vindas do MarketPlacesController
  const { buscarMarketplaces, buscarMarketplacesEmpresa } =
    useMarketPlacesController();

  // Carrega todos os campos específicos que iniciam com a tela (usando useEffect para serem carregados somente uma vez)
  useEffect(() => {
    setCnpj(params.cnpj.replace(/\D/g, ""));

    // Coloca a empresa no context
    (async () => {
      let retorno = await findEmpresa(params.cnpj.replace(/\D/g, ""));
      if (retorno.success) {
        let empresaData = retorno.data ? retorno.data[0] : null;
        setEmpresa(empresaData);
      }
    })();

    const tabIndexStorage = sessionStorage.getItem("tabIndex")
      ? Number.parseInt(sessionStorage.getItem("tabIndex"))
      : tabIndex;
    setTabIndex(tabIndexStorage);
    sessionStorage.removeItem("tabIndex");
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!cnpj) return;

    // Busca todos os estoques desse CNPJ
    (async () => {
      setEstoquesLoading(true);
      const buscaEstoque = await findEstoque(cnpj);
      if (buscaEstoque && buscaEstoque.success && buscaEstoque.data) {
        setEstoques(buscaEstoque.data);
      } else {
        setEstoques([]);
      }
      setEstoquesLoading(false);
    })();

    // Busca todos os Fabricantes
    (async () => {
      setFabricantesLoading(true);
      const buscaFabricante = await findFabricante(cnpj);
      if (buscaFabricante && buscaFabricante.success && buscaFabricante.data) {
        setFabricantes(buscaFabricante.data);
      } else {
        setFabricantes([]);
      }
      setFabricantesLoading(false);
    })();

    // Busca todos os Grupos de produtos
    (async () => {
      setGruposLoading(true);
      const buscaGrupos = await findGrupo(cnpj);
      if (buscaGrupos && buscaGrupos.success && buscaGrupos.data) {
        setGrupos(buscaGrupos.data);
      } else {
        setGrupos([]);
      }
      setGruposLoading(false);
    })();

    // Busca todos os Marketplaces
    (async () => {
      let marketplaces = await buscarMarketplaces();
      marketplaces = Array.isArray(marketplaces) ? marketplaces : [];
      setMarketplaceList(marketplaces);
    })();

    // Busca todos os marketplaces conectados
    (async () => {
      let marketplacesConectados = await buscarMarketplacesEmpresa(cnpj);
      setMarketplacesConectados(
        Array.isArray(marketplacesConectados) ? marketplacesConectados : []
      );
    })();
    // eslint-disable-next-line
  }, [cnpj]);

  // UseEffect mutaveis
  // Caso a pessoa tenha selecionado um marketplace, busca os dados dele
  // eslint-disable-next-line
  useEffect(async () => {
    let marketplaceId = sessionStorage.getItem("marketplaceId")
      ? sessionStorage.getItem("marketplaceId")
      : "0";

    if (marketplace && marketplace.id === parseInt(marketplaceId)) return;

    let marketplacesConectados = await buscarMarketplacesEmpresa(cnpj);
    setMarketplacesConectados(
      Array.isArray(marketplacesConectados) ? marketplacesConectados : []
    );

    if (marketplaceId !== "0" && marketplacesConectados) {
      let mkp = marketplacesConectados.find((mktpList) => {
        return mktpList.id === parseInt(marketplaceId);
      });
      setMarketplace(mkp);
    }
    // eslint-disable-next-line
  }, [cnpj, marketplaceList, marketplace]);

  // Abaixo será feito somente a construção da tela

  const headers = [
    {
      label: "Marketplace",
      icon: <StorefrontIcon />,
    },
    {
      label: "Produtos",
      icon: <ShoppingCart />,
      disabled: marketplaceId ? false : true,
    },
  ];

  // Somente empresas MEI/ME tem acesso as configurações (Tributação)
  if (
    empresa &&
    empresa.crt &&
    (Number(empresa.crt) === 1 || Number(empresa.crt) === 2)
  ) {
    headers.push({
      label: "Configurações",
      icon: <SettingsIcon />,
      disabled: marketplaceId ? false : true,
    });
  }

  headers.push({
    label: "Desconectar",
    icon: <DeleteIcon />,
    disabled: marketplacesConectados.length === 0,
  });

  const children = [
    <MarketplacesTabMarketplaces key="mrkttab_marketplaces" />,
    <MarketplacesTabProdutos key="mrkttab_produtos" />,
  ];

  if (
    empresa &&
    empresa.crt &&
    (Number(empresa.crt) === 1 || Number(empresa.crt) === 2)
  )
    children.push(<MarketplacesTabConfiguracoes key="mrkttab_configuracoes" />);

  children.push(<MarketplacesTabDesconectar key="mrkttab_desconectar" />);

  return (
    <div className="fluid-container">
      <div className="container">
        <Title
          key="Marketplace_title"
          titulo="Integração Marketplaces"
          icon={StorefrontIcon}
        />
        <TabsErp
          headers={headers}
          children={children}
          tabIndex={tabIndex}
          onChange={(event, value) => {
            if (Number.isInteger(value)) setTabIndex(value);
          }}
        />
      </div>
    </div>
  );
};

export default Marketplaces;
